import { commonImages } from '@images/common-images';
import { dashboardImages } from '@images/dashboard-images';

const homeIcon = commonImages?.home_sidebar_icon;
const emailIcon = dashboardImages?.email_icon;
const listingIcon = commonImages?.listing_icon;
const marketPlaceIcon = commonImages?.marketplace_icon;
const projectIcon = commonImages?.project_1;
const leadIcon = commonImages?.lead_icon;
const contractIcon = commonImages?.contract_icon;
const taskIcon = commonImages?.task_icon;
const reportIcon = commonImages?.report_icon;
const contactIcon = commonImages?.phoneBook_icon;
const libraryIcon = commonImages?.folder_icon;
const historyIcon = commonImages?.history_icon;
const settingIcon = commonImages?.settings_icon;
const pinIcon = commonImages?.pin_icon;
const pinnedIcon = commonImages?.pinned_icon;
const calendar = commonImages?.calendar_icon_v2;
const dots = commonImages?.dots_icon;

export const SideMenu = [
  // Dashboard
  {
    id: 99999999999999,
    title: 'Dashboard',
    slug: 'dashboard',
    icon: homeIcon,
    link: '/',
  },
  // Email
  {
    id: 0,
    title: 'Email',
    slug: 'gmail',
    icon: emailIcon,
    link: '/my-inbox',
    permissions: ['leademail.manage'],
  },
  // Calendar
  {
    id: 90909,
    title: 'Calendar',
    slug: 'calender',
    icon: calendar,
    link: '/calender',
    permissions: ['calendar.manage'],
  },
  // 3 Task Manager
  {
    id: 3,
    title: 'Task',
    slug: 'task-manager',
    icon: taskIcon,
    link: '/tasks/tasks-overview',
    permissions: ['task.show'],
  },
  // 2 Lead management
  {
    id: 2,
    title: 'Lead',
    slug: 'lead-management',
    icon: leadIcon,
    link: '/leads/lead-overview',
    permissions: ['lead.manage', 'lead.view'],
  },
  // 5 Contacts
  {
    id: 5,
    title: 'Contacts',
    icon: contactIcon,
    link: '/setting/office-contact',
    permissions: ['contact.view', 'developer.view', 'user.view', 'staff.view', 'team.manage', 'offices.manage', 'groups.manage'],
  },
  // Listing
  {
    id: 1,
    title: 'Listings',
    slug: 'my-listings',
    icon: listingIcon,
    link: '/listings/listing-properties',
    permissions: ['allproperties.manage', 'allproperties.view'],
  },
  // Projects
  {
    id: 9,
    title: 'Projects',
    slug: 'my-listings',
    icon: projectIcon,
    link: '/project/projects',
    permissions: ['allprojects.edit', 'allprojects.view', 'allprojects.manage'],
  },
  // contracts
  {
    id: 'a2',
    title: 'Contracts',
    icon: contractIcon,
    link: '/contracts',
    permissions: ['contract.manage', 'contract.view'],
  },
  // 4 Reports
  {
    id: 4,
    title: 'Reports',
    slug: 'reports',
    icon: reportIcon,
    link: '/report/create-report',
    permissions: ['report.view', 'report.create', 'report.edit', 'report.delete'],
  },
  // History
  {
    id: 71,
    title: 'History',
    slug: 'history',
    icon: historyIcon,
    permissions: ['history.view'],
    // link: "/history",
    childs: [
      {
        id: 213,
        childTitle: 'Recent Item',
        childTitleIcon: 'ri ri-history-line',
        subChilds: [],
      },
    ],
  },
  // Pin
  {
    id: 999999999999999,
    title: 'Pin',
    slug: 'Pin',
    icon: pinIcon,
    childs: [
      {
        id: 11,
        childTitle: 'Pinned',
        childTitleIcon: pinnedIcon,
      },
    ],
  },
  // 6 Library
  {
    id: 6,
    title: 'Library',
    slug: 'library',
    icon: libraryIcon,
    permissions: ['library.icentra.view', 'library.office.view', 'library.settings.manage', 'setting.library.setup'],
    link: '/library/private',
  },
  // Marketplace
  {
    id: 10101,
    title: 'Market Place',
    slug: 'market-place',
    icon: marketPlaceIcon,
    link: '/listings/market-place',
    permissions: ['market.view'],
  },
  // 8 Settings
  {
    id: 8,
    title: 'Settings',
    slug: 'settings',
    icon: settingIcon,
    link: '/setting/setup/visibility',
    permissions: [
      'entitymanager.manage',
      'setting.template.view',
      'task.jobtype.manage',
      'task.priority.manage',
      'task.marketing.manage',
      'task.status.create',
      'task.status.edit',
      'task.status.delete',
      'setting.site.view',
      'library.settings.manage',
      'setting.activity.view',
      'setting.visibility.setup',
      'setting.access.setup',
      'setting.library.setup',
      'setting.tag_manager.setup',
      'permissions.manage',
      'level.manage',
      'menu.add',
      'menu.edit',
      'rolemenu.add',
      'rolemenu.edit',
    ],
  },
  // External Contacts
  {
    id: 202220,
    title: 'Contact',
    slug: 'staff-contact',
    icon: contactIcon,
    link: '/staff-contact',
    permissions: ['externalestaff.view'],
  },
  // Hidden
  {
    id: 61,
    title: 'Hidden',
    slug: 'others___1',
    icon: dots,
    permissions: [],
    childs: [],
  },
];
